import React, { useEffect } from 'react';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { Table } from 'components/molecules/Table';
import {
  mapApplicationToDataSource,
  myApplicationsTableColumns,
} from 'pages/MyApplicationsPage/helpers';
import { Grid } from '@mui/material';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ApplicationStatus } from 'models/application';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EChipsVariants } from 'components/atoms/Chips';
import { ERouteLinks } from 'models/route';
import { useAlert } from 'models/alertContext';
import { ActionTypes } from 'state/actions/alert';
import { Alert } from 'components/atoms/Alert';
import { useMyApplication } from './hooks';

// const data = [
//   {
//     id: '00112233-4455-6677-8899-aabbccddeeff',
//     name: 'Application for a Certificate to Possess a Shotgun',
//     date: '12-04-2025',
//     status: ApplicationStatus.Drafting,
//   },
//   {
//     id: '00112233-4455-6677-8899-aabbccddee00',
//     name: 'Application for a Certificate to Possess a Firearm/s',
//     date: '02-04-2025',
//     status: ApplicationStatus.Denied,
//   },
// ];

const MyApplicationsPage = () => {
  const { applications, getMyApplication } = useMyApplication();
  const { nextPageAlert, clearAlert } = useAlert();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(
    () => () => {
      clearAlert(ActionTypes.CLEAR_NEXT_PAGE_ALERT);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    (async () => {
      await getMyApplication();
    })();
  }, []);

  const handlerAddAttachment = (id: string) => {
    // eslint-disable-next-line no-console
    console.log('handleAddAttachment', id);
  };
  const handlerShowDetails = (id: string) => {
    // eslint-disable-next-line no-console
    console.log('handleShowDetails', id);
    navigate(`${ERouteLinks.ApplicationDetails.replace(':id', id)}`);
  };
  const handlerPayNow = (id: string) => {
    // eslint-disable-next-line no-console
    console.log('handlePayNow', id);
  };

  const handlerAppeal = (id: string) => {
    // eslint-disable-next-line no-console
    console.log('handleAppeal', id);
  };

  const getStatusVariant = (status: string): EChipsVariants => {
    switch (status) {
      case ApplicationStatus.Approved:
      case ApplicationStatus.NewApplication:
        return EChipsVariants.success;
      case ApplicationStatus.Drafting:
        return EChipsVariants.inactive;
      case ApplicationStatus.Submitted:
      case ApplicationStatus.Assessment:
        return EChipsVariants.primary;
      case ApplicationStatus.ActionRequired:
        return EChipsVariants.warning100;
      case ApplicationStatus.Denied:
        return EChipsVariants.error200;
      default:
        return EChipsVariants.primary;
    }
  };

  return (
    <>
      <Breadcrumbs items={['My Applications']} />
      <Grid container>
        <Grid item xs={6}>
          <StyledPageTitle variant="h4">My Applications</StyledPageTitle>
        </Grid>
      </Grid>
      <Table
        loading={false}
        columns={myApplicationsTableColumns({
          handleAddAttachment: (id) => handlerAddAttachment(id),
          handleShowDetails: (id) => handlerShowDetails(id),
          handlePayNow: (id) => handlerPayNow(id),
          handleAppeal: (id) => handlerAppeal(id),
          statusVariant: (status: string) => getStatusVariant(status),
          t,
        })}
        dataSource={mapApplicationToDataSource(applications)}
      />
      {nextPageAlert && (
        <Grid item xs={12} mt={2}>
          <Alert text={nextPageAlert.text} variant={nextPageAlert.variant} />
        </Grid>
      )}
    </>
  );
};

export { MyApplicationsPage };
